import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import {
  getStoredUserType,
  isPathAllowedForRole,
} from "../utils/roleAccess";

const RoleRouteGuard = ({ children }) => {
  const location = useLocation();
  const userType = getStoredUserType();

  if (!isPathAllowedForRole(userType, location.pathname)) {
    return <Redirect to="/" />;
  }

  return children;
};

export default RoleRouteGuard;
